import React, { Component } from "react";
import PropTypes from "prop-types";
import fordStyles from "./DashboardCards-Ford.module.scss";
import lincolnStyles from "./DashboardCards-Lincoln.module.scss";
import { Content } from "./DashboardContent";
import { DashboardActions } from "./DashboardActions";
import HasPermissionTo from "../../../common/HasPermissionTo";
import { IS_CANADA_MARKET } from "../../../utils/EmpUtil";
import { isCanadianPreorderUser } from "../../../utils/canadianPreorderExperience";
import {
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Grid,
} from "@mui/material";

const getStyles = (brand) => (brand === "L" ? lincolnStyles : fordStyles);

class MainDashboard extends Component {
  render() {
    const styles = getStyles(this.props.user.brand);
    const isLincoln = this.props.user.brand === "L";
    const isCanadianPreorder = isCanadianPreorderUser(this.props.user);
    const { preorder } = this.props.dashboardNotifications;
    const preorderData = preorder
      ? { totalAddedToday: preorder.addedToday }
      : undefined;

    return (
      <div className={styles.pagePadding}>
        <Grid
          container
          spacing={4}
          alignItems="stretch"
          justifyContent="center"
        >
          {(!isLincoln || isCanadianPreorder) && (
            <HasPermissionTo
              perform={isCanadianPreorder ? [] : ["preorderDashboardCard"]}
              permissions={this.props.user.permissions.rolePermissions}
              condition={
                !IS_CANADA_MARKET(this.props.user.market) || isCanadianPreorder
              }
              render={() => (
                <Grid item xs={12} sm={6} md={6}>
                  <DashboardCard
                    {...this.props}
                    type="preorder"
                    title={this.props.t("DealerDashboard.preorders")}
                    data={preorderData}
                    testid="preorders-card"
                    pathname=""
                    location="customer_handling"
                    viewAllTag="intcmp=emphp-cta-preorderscard-viewall"
                    hideActionButton
                  />
                </Grid>
              )}
            />
          )}
          <HasPermissionTo
            perform={["modelEDashboardCard"]}
            permissions={this.props.user.permissions.rolePermissions}
            render={() => (
              <Grid item xs={12} sm={6} md={6}>
                <DashboardCard
                  {...this.props}
                  type="modele"
                  title={this.props.t("DealerDashboard.purchaseRequests")}
                  data={this.props.dashboardNotifications.purchaseRequest}
                  testid="purchase-requests-card"
                  pathname=""
                  location="model_e_orders"
                  viewAllTag="intcmp=emphp-cta-modelecard-viewall"
                  hideActionButton
                />
              </Grid>
            )}
          />
        </Grid>
      </div>
    );
  }
}

const DashboardCard = (props) => {
  const isLincoln = props.user.brand === "L";
  const styles = getStyles(props.user.brand);

  return (
    <Card data-testid={props.testid} className={styles.card} variant="outlined">
      <CardHeader
        className={isLincoln ? styles.title : undefined}
        title={props.title}
        titleTypographyProps={{
          variant: "h4",
          sx: {
            color: isLincoln ? "#485B65" : "primary.main",
            textAlign: "center",
            ...(isLincoln && {
              fontSize: "24px",
              textTransform: "none",
            }),
          },
        }}
        sx={{ p: 0 }}
      />
      <CardContent>
        <Content {...props} />
      </CardContent>
      <CardActions className={isLincoln ? styles.cardActions : undefined}>
        <DashboardActions
          {...props}
          buttonClassName={isLincoln ? styles.button : undefined}
        />
      </CardActions>
    </Card>
  );
};

MainDashboard.propTypes = {
  user: PropTypes.shape({
    permissions: PropTypes.shape({
      rolePermissions: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    }).isRequired,
  }).isRequired,
  t: PropTypes.func.isRequired,
  dashboardNotifications: PropTypes.shape({
    purchaseRequest: PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.object,
      PropTypes.number,
      PropTypes.string,
    ]),
    preorder: PropTypes.shape({
      addedToday: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    }),
  }).isRequired,
};

DashboardCard.propTypes = {
  testid: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default MainDashboard;
